
import * as Yup from "yup";
import ButtonWithLoader from "../../../utils/ButtonWithLoader"
import Languages from "../../../utils/Languages";
import { Language } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../../utils/TranslateTextField";
import DataGrids from "../../../utils/Datagrids";
import React, { useEffect, useState } from "react";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import { getISTDate } from "../../../utils/Constant";
import HOST_URL from "../../../utils/Url";
import Card from "@mui/material/Card";
import {
  Grid,
  Input,
  Box,
  Button,
  Divider,
  Stack,
  TextField,
  Typography,
  checkboxClasses,
  FormControlLabel,
  Checkbox,
  FormControl,
  RadioGroup,
  Radio,
  Autocomplete,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import { useNavigate, useLocation } from "react-router-dom";
import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import DeleteIcon from "@mui/icons-material/Delete";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import CircularProgress from "@mui/material/CircularProgress";
import api from "../../../utils/Url";
import { useFormik } from "formik";
import CustomLabel from "../../../CustomLable";
import DownloadIcon from "@mui/icons-material/Download";
import RefreshIcon from "@mui/icons-material/Refresh";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { jsPDF } from "jspdf";
import * as XLSX from "xlsx";
interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
}
export default function FuelBalCorrection() {
  const [zones, setZones] = useState([]);
  const { defaultValues } = getISTDate();
  const [columns, setColumns] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [editId, setEditId] = useState(-1);
  const [isPrint, setPrint] = useState([]);
  const [selectedFormat, setSelectedFormat] = useState<any>("pdf");
  const [vNO, setVno] = useState([]);
  

  const handleFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedFormat((event.target as HTMLInputElement).value);
  };
  const [VnoOption, setVnoOption] = useState([
    { value: -1, label: ("text.itemMasterId") },
  ]);
  let navigate = useNavigate();
  const { t } = useTranslation();
  useEffect(() => {
    getVnoData();
  }, []);
  const handleChange = (event: any, newValue: any) => {

    const selectedValues = newValue.map((item: any) => item.value);
                //console.log(selectedValues);
                setVno(selectedValues);

  };
  const getVnoData = () => {
    const collectData = {
      orderby: "",
      pageNo: 0,
      pageSize: 0,
      intnotnullvalue1: 0,
      userId: "",

      str1: "",
      str2: "",
      str3: "",
      str4: "",
      str5: "",
      intvalue1: 0,
      intvalue2: 0,
      intvalue3: 0,
      intvalue4: 0,
      intnotnullvalue2: 0,
      intnotnullvalue3: 0,
      date1: new Date().toISOString(),
      date2: new Date().toISOString(),
      date3: new Date().toISOString(),
      date4: new Date().toISOString(),
      dec1: 0,
      dec2: 0,
      dec3: 0,
      dec4: 0,
      flag: true,
      data: "",
      success: true,
      error: "",
      selectPerindex: 0,
      show: true,
    };
    api.post(`Dashboard/GetvVehicleNo`, collectData).then((res) => {
      const arr = res?.data?.data.map((item: any) => ({
        label: item.vehicleNo,
        value: item.vehicleNo,
      }));
      setVnoOption(arr);
    });
  };
  const handleConversionChange = (params: any, text: string) => {
    formik.setFieldValue(params, text);
  }
  const handleSwitchChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: any
  ) => {
    const collectData = {
      corrId: value.id,
      vehicleNo: value.vehicleNo,
      devid: value.devid,
      itemMasterId: value.itemMasterId,
      correctedOB: value.correctedOB,
      correctionDate: value.correctionDate,
      //isActive: event.target.checked,
      sortOrder: value.sortOrder,
    };
    api.post(`FuelCorrection/AddUpdateFuelCorrection`, collectData).then((response) => {
      if (response.data.isSuccess) {
        toast.success(response.data.msg);
        fetchFuelData();
      } else {
        toast.error(response.data.msg);
      }
    });
  };
  const routeChangeEdit = (row: any) => {
    console.log(row);
    formik.setFieldValue("corrId", row.corrId);
    formik.setFieldValue("correctionDate", row.correctionDate);
    formik.setFieldValue("itemMasterId", row.itemMasterId);
    formik.setFieldValue("divisionId", row.divisionId);
    formik.setFieldValue("selectedOB", row.selectedOB);
    formik.setFieldValue("correctedOB", row.correctedOB);
    formik.setFieldValue("createdOn", row.createdOn);
    formik.setFieldValue("updatedOn", row.updatedOn);
    formik.setFieldValue("vehicleNo", row.vehicleNo);
    formik.setFieldValue("devid", row.devid);
    setEditId(row.id);
  };
  const fetchFuelData = async () => {
    try {
      const collectData = {
        "str1": "",
        "str2": "",
        "str3": "",
        "str4": "",
        "str5": "",
        "str6": "",
        "intvalue1": 0,
        "intvalue2": 0,
        "intvalue3": 0,
        "intvalue4": 0,
        "intnotnullvalue1": 0,
        "intnotnullvalue2": 0,
        "intnotnullvalue3": 0,
        "list1":vNO ? vNO : [],
        "listInt1": [
          0
        ],
        "list2": [
          ""
        ],
        "listInt2": [
          0
        ],
        "listInt12": [
          ""
        ],
        "date1": defaultValues,
        "date2": defaultValues,
        "date3": defaultValues,
        "date4": defaultValues,
        "dec1": 0,
        "dec2": 0,
        "dec3": 0,
        "dec4": 0,
        "flag": true,
        "data": "",
        "success": true,
        "error": "",
        "selectPerindex": 0,
        "selectedPeriod": {
          "index": 0,
          "startDate": defaultValues,
          "endDate": defaultValues,
          "daysOnly": true,
          "displayLabel": ""
        },
        "listPeriod": [
          {
            "index": 0,
            "startDate": defaultValues,
            "endDate": defaultValues,
            "daysOnly": true,
            "displayLabel": ""
          }
        ],
        "selectPerindex1": 0,
        "selectedPeriod1": {
          "index": 0,
          "startDate": defaultValues,
          "endDate": defaultValues,
          "daysOnly": true,
          "displayLabel": ""
        },
        "listPeriod1": [
          {
            "index": 0,
            "startDate": defaultValues,
            "endDate": defaultValues,
            "daysOnly": true,
            "displayLabel": ""
          }
        ],
        "show": true,
        "empName": "",
        "zoneName": "",
        "departmentName": "",
        "exportOption": "",
        "all": true,
        "conditionStr1": "",
        "conditionStr2": "",
        "condition1": true,
        "condition2": true,
        "expOption": [
          {
            "ext": "",
            "extname": ""
          }
        ],
        "cancel": {
          "waitHandle": {
            "handle": {},
            "safeWaitHandle": {}
          }
        }
      }
      const response = await api.post(
        `FuelCorrection/GetVehList`, collectData);
      const data = response.data.data;
      console.log("🚀 ~ fetchFuelData ~ response.data.data:", response.data.data)
      const zonesWithIds = data.map((Item: any, index: any) => ({
        ...Item,
        serialNo: index + 1,
        id: index + 1
      }));
      setZones(zonesWithIds);
      setIsLoading(false);
      if (data.length > 0) {
        const columns: GridColDef[] = [
          {
            field: "actions",
            headerName: t("text.Action"),
            width: 150,
            renderCell: (params) => (
              <Stack
                spacing={1}
                direction="row"
                sx={{ alignItems: "center", marginTop: "5px" }}
              >
                <Checkbox
                  size="small"
                  color="primary"
                  checked={params.row.checked || false}
                  onChange={(e) => {
                    const isChecked = e.target.checked;

                    // Update Formik fields dynamically when the checkbox is toggled
                    formik.setFieldValue("vehicleNo", params.row.vehicleNo);
                    formik.setFieldValue("correctionDate", params.row.trackDate);
                    formik.setFieldValue("devid", params.row.devid);
                   // formik.setFieldValue("correctedOB", params.row.correctedOB || 0);
                   // formik.setFieldValue("correctedOB", updatedValue);
                   
                  }}
                />
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  onClick={() => {
                    formik.handleSubmit(); // Trigger form submission
                  }}
                >
                  Save
                </Button>
              </Stack>
            ),
          },
          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "vehicleNo",
            headerName: t("text.vehicleNo"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "devid",
            headerName: t("text.devid"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "correctionDate",
            headerName: t("text.correctionDate"),
            flex: 1,
            editable: true,
            renderCell: (params) => (
              <TextField
                type="date"
                size="small"
                variant="outlined"
                defaultValue={params.value ? new Date(params.value).toISOString().split("T")[0] : ""}
                onBlur={(e) => formik.setFieldValue("correctionDate", e.target.value)} 
              />
            ),
          },
          {
            field: "openingBal",
            headerName: t("text.opBalanceExist"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
        


          {
            field: "correctedOB",
            headerName: t("text.opBalanceCorr"),
            flex: 1,
            editable: true,
            renderCell: (params) => (
              <TextField
                name="correctedOB"
                size="small"
                variant="outlined"
              //  value={formik.values.correctedOB} // Use Formik state
                onChange={(e) => formik.setFieldValue("correctedOB", e.target.value)}
                onBlur={formik.handleBlur}
              />
            ),
          }
          
        ];
        setColumns(columns as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };
  const adjustedColumns = columns.map((column: any) => ({
    ...column,
  }));
  const formik = useFormik({
    initialValues: [{
      "corrId": 0,
      "correctionDate": defaultValues,
      "itemMasterId": 0,
      "selectedOB": 0,
      "correctedOB": 0,
      "createdBy": "",
      "updatedBy": "",
      "createdOn": defaultValues,
      "updatedOn": defaultValues,
      "vehicleNo": "",
      "devid": ""
    }],
  // 
  onSubmit: async (values) => {
    console.log("Submitting values:", values);
    const response = await api.post(
      `FuelCorrection/AddUpdateFuelCorrection`,
      values
    );
    if (response.data.isSuccess) {
      toast.success(response.data.msg);
      fetchFuelData();
    } else {
      toast.error(response.data.msg);
    }
  },
});
  return (
    <>
      <Card
        style={{
          width: "100%",
          backgroundColor: "#E9FDEE",
          marginTop: "3vh",
        }}
      >
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
            "& .MuiDataGrid-colCell": {
              backgroundColor: `var(--grid-headerBackground)`,
              color: `var(--grid-headerColor)`,
              fontSize: 17,
              fontWeight: 900,
            },
          }}
          style={{ padding: "10px" }}
        >
          <ConfirmDialog />
          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{ padding: "20px" }}
            align="left"
          >
            {t("text.FuelBalCorrection")}
          </Typography>
          <Divider />
          <Box height={10} />
          <Grid container spacing={2} sx={{ marginTop: "3vh" }}>
            <Grid item xs={12}>
              <Autocomplete
                disableCloseOnSelect
                multiple
                options={VnoOption}
                getOptionLabel={(option) => option.label}
                fullWidth
                size="small"
                onChange={handleChange}
                renderOption={(props, option, { selected }) => (
                  <li {...props} style={{ display: "flex", alignItems: "center" }}>
                    <Checkbox checked={selected} style={{ marginRight: 8 }} />
                    <span>{option.label}</span>
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={<CustomLabel text={t("text.VehicleNos1")} />}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Button
                    type="submit"
                    fullWidth
                    style={{
                      backgroundColor: `var(--header-background)`,
                      color: "white",
                      marginTop: "10px",
                    }}
                    onClick={() => {
                      fetchFuelData();
                      setVisible(true);
                    }}
                    startIcon={<VisibilityIcon />}
                  >
                    Show
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    type="button"
                    fullWidth
                    style={{
                      backgroundColor: `#f44336`,
                      color: "white",
                      marginTop: "10px",
                    }}
                    startIcon={<RefreshIcon />}
                    onClick={() => {
                      formik.resetForm();
                    }}
                  >
                    Reset
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            container
            spacing={2}
            sx={{ marginTop: "3%", justifyContent: "center" }}
          >
            {visible && (
              <Grid item xs={12} sm={12} lg={12}>
                {isLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <CircularProgress />
                  </div>
                ) : (
                  <DataGrid
                    rows={zones}
                    columns={adjustedColumns}
                    rowSpacingType="border"
                    autoHeight

                    pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
                      value: size,
                      label: `${size}`,
                    }))}
                    initialState={{
                      pagination: { paginationModel: { pageSize: 5 } },
                    }}
                    slotProps={{
                      toolbar: {
                        showQuickFilter: true,
                      },
                    }}
                    sx={{
                      border: 0,
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: "#42b6f5",
                        color: "white",
                      },
                      "& .MuiDataGrid-columnHeaderTitle": {
                        color: "white",
                      },
                    }}
                  />
                )}
              </Grid>
            )}
          </Grid>
        </Paper>
      </Card>
      <ToastApp />
    </>
  );
}
function handleUpdateRow(row: any): void {
  throw new Error("Function not implemented.");
}
function handleCheckboxChange(row: any, isChecked: boolean) {
  throw new Error("Function not implemented.");
}

